export const table = [
  {
    name: "Argue, Tracy",
    role: "Administrator",
    subdivision: "Verona",
    phoneNumber: "(972) 265-1154",
  },
];



// WEBPACK FOOTER //
// ./src/components/pages/Statistics/table.js